<template>
  <div>
    <div class="mainHeading">Employee headcount</div>
    <div class="mainDescription mb-4">
      This report shows up-to-date list of employees in selected time period.
    </div>
    <div class="dropdownsContainer">
      <b-dropdown no-caret class="primaryBorderDropdown">
        <template #button-content>
          <div class="button-content">
            <div class="buttonContentText">All time</div>
            <b-icon class="downIcon" icon="caret-down-fill" />
          </div>
        </template>
        <b-dropdown-item >
          All time
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown no-caret class="primaryBorderDropdown">
        <template #button-content>
          <div class="button-content">
            <div class="buttonContentText">All employees</div>
            <b-icon class="downIcon" icon="caret-down-fill" />
          </div>
        </template>
        <b-dropdown-item >
          All employees
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown no-caret class="primaryBorderDropdown">
        <template #button-content>
          <div class="button-content">
            <div class="buttonContentText">All teams</div>
            <b-icon class="downIcon" icon="caret-down-fill" />
          </div>
        </template>
        <b-dropdown-item >
          All teams
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown no-caret class="primaryBorderDropdown">
        <template #button-content>
          <div class="button-content">
            <div class="buttonContentText">All locations</div>
            <b-icon class="downIcon" icon="caret-down-fill" />
          </div>
        </template>
        <b-dropdown-item >
          All locations
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown no-caret class="primaryBorderDropdown">
        <template #button-content>
          <div class="button-content">
            <div class="buttonContentText">All positions</div>
            <b-icon class="downIcon" icon="caret-down-fill" />
          </div>
        </template>
        <b-dropdown-item >
          All positions
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown no-caret class="primaryBorderDropdown">
        <template #button-content>
          <div class="button-content">
            <div class="buttonContentText">All genders</div>
            <b-icon class="downIcon" icon="caret-down-fill" />
          </div>
        </template>
        <b-dropdown-item >
          All genders
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="w-100 d-flex align-items-center justify-content-center">
      <div id="container"></div>
    </div>
    <b-dropdown no-caret class="primaryBorderDropdown mt-32px mr-0">
      <template #button-content>
        <div class="button-content">
          <div class="buttonContentText">All</div>
          <b-icon class="downIcon" icon="caret-down-fill" />
        </div>
      </template>
      <b-dropdown-item >
        All 
      </b-dropdown-item>
    </b-dropdown>
    <div class="HeadCountTable mt-32px">
      <div class="HrmTableHead-container">
        <div class="HrmTableHead one">Employee</div>
        <div class="HrmTableHead two">team</div>
        <div class="HrmTableHead three">start date</div>
        <div class="HrmTableHead four">last working day</div>
        <div class="HrmTableHead five">Length of employment</div>
      </div>
      <vb-table class="HrmTable">
        <template #body>
          <tr class="dialer-row-select">
            <td class="dialer-row-title one">
              <div class="nameWithImage">
                <div class="imageContainer">
                  <img :src="require('@/assets/images/credit-card/1.jpeg')" />
                </div>
                <div class="nameWithImage-text">Marie jane</div>
              </div>
            </td>
            <td class="dialer-row-title two">UK - Digital production</td>
            <td class="dialer-row-title three">10/07/2017</td>
            <td class="dialer-row-title four">10/07/2022</td>
            <td class="dialer-row-title five">5 years 2 months</td>
          </tr>
          <tr class="dialer-row-select">
            <td class="dialer-row-title one">
              <div class="nameWithImage">
                <div class="imageContainer">
                  <img :src="require('@/assets/images/credit-card/2.jpeg')" />
                </div>
                <div class="nameWithImage-text">Morgan</div>
              </div>
            </td>
            <td class="dialer-row-title two">UK - Digital production</td>
            <td class="dialer-row-title three">10/07/2017</td>
            <td class="dialer-row-title four">10/07/2022</td>
            <td class="dialer-row-title five">5 years 2 months</td>
          </tr>
          <tr class="dialer-row-select">
            <td class="dialer-row-title one">
              <div class="nameWithImage">
                <div class="imageContainer">
                  <img :src="require('@/assets/images/credit-card/3.jpeg')" />
                </div>
                <div class="nameWithImage-text">Jason</div>
              </div>
            </td>
            <td class="dialer-row-title two">UK - Digital production</td>
            <td class="dialer-row-title three">10/07/2017</td>
            <td class="dialer-row-title four">10/07/2022</td>
            <td class="dialer-row-title five">5 years 2 months</td>
          </tr>
          <tr class="dialer-row-select">
            <td class="dialer-row-title one">
              <div class="nameWithImage">
                <div class="imageContainer">
                  <img :src="require('@/assets/images/credit-card/4.jpeg')" />
                </div>
                <div class="nameWithImage-text">Lauren German</div>
              </div>
            </td>
            <td class="dialer-row-title two">UK - Digital production</td>
            <td class="dialer-row-title three">10/07/2017</td>
            <td class="dialer-row-title four">10/07/2022</td>
            <td class="dialer-row-title five">5 years 2 months</td>
          </tr>
        </template>
      </vb-table>
    </div>
  </div>
</template>

<script>
import { HRM } from '@/data'
var Highcharts = require('highcharts');
export default {
  name: 'Headcount',
  data(){
    return {
      dataset: {
        chart: {
          type: 'area'
        },
        title: {
          text: 'headcount'
        },
        xAxis: {
          categories: ["February 2010","March 2010","April 2010","May 2010","June 2010","July 2010","August 2010","September 2010","October 2010","November 2010","December 2010","January 2011","February 2011","March 2011","April 2011","May 2011","June 2011","July 2011","August 2011","September 2011","October 2011","November 2011","December 2011","January 2012","February 2012","March 2012","April 2012","May 2012","June 2012","July 2012","August 2012","September 2012","October 2012","November 2012","December 2012","January 2013","February 2013","March 2013","April 2013","May 2013","June 2013","July 2013","August 2013","September 2013","October 2013","November 2013","December 2013","January 2014","February 2014","March 2014","April 2014","May 2014","June 2014","July 2014","August 2014","September 2014","October 2014","November 2014","December 2014","January 2015","February 2015","March 2015","April 2015","May 2015","June 2015","July 2015","August 2015","September 2015","October 2015","November 2015","December 2015","January 2016","February 2016","March 2016","April 2016","May 2016","June 2016","July 2016","August 2016","September 2016","October 2016","November 2016","December 2016","January 2017","February 2017","March 2017","April 2017","May 2017","June 2017","July 2017","August 2017","September 2017","October 2017","November 2017","December 2017","January 2018","February 2018","March 2018","April 2018","May 2018","June 2018","July 2018","August 2018","September 2018","October 2018","November 2018","December 2018","January 2019","February 2019","March 2019","April 2019","May 2019","June 2019","July 2019","August 2019","September 2019","October 2019","November 2019","December 2019","January 2020","February 2020","March 2020","April 2020","May 2020","June 2020","July 2020","August 2020","September 2020","October 2020","November 2020","December 2020","January 2021","February 2021","March 2021","April 2021","May 2021","June 2021","July 2021","August 2021","September 2021","October 2021","November 2021","December 2021","January 2022","February 2022","March 2022","April 2022","May 2022","June 2022","July 2022","August 2022","September 2022"] 
        },
        yAxis:{
          max: 40
        },
        tooltip: {
          shared: true,
          headerFormat: '<span style="font-size:12px"><b>{point.key}</b></span><br>'
        },
        plotOptions: {
          // series: {
          //   pointStart: 2012
          // },
          area: {
            // stacking: 'normal',
            lineColor: '#666666',
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: '#666666'
            }
          }
        },
        series: [{
          name: 'All',
          color: 'hwb(224deg 93% 1%)',
          data: HRM.charts.headCount.all
        }, {
          name: 'Full-time',
          color: 'hwb(224deg 86% 4%)',
          data: HRM.charts.headCount.fullTime
        }, {
          name: 'Agriculture and hunting',
          color: 'hwb(226deg 80% 5%)',
          data: HRM.charts.headCount.agricultureAndHunting
        }, {
          name: 'Contract',
          color: 'hwb(224deg 86% 3%)',
          data: HRM.charts.headCount.Contract

        }, {
          name: 'Intern',
          color: 'hwb(224deg 66% 9%)',
          data: HRM.charts.headCount.Intern
        }]
      }
    }
  },
  methods: {
    headCoutChart(){
      Highcharts.chart('container', this.dataset)
    }
  },
  mounted(){
    this.headCoutChart()
  }
}
</script>

<style>

</style>